<script>
import dayjs from 'dayjs'

const loginEffectiveTime = 480; // 以分钟计算
const clientHeight = document.documentElement.clientHeight; //获取浏览器窗口的可视区域的高度
const clientWidth = document.documentElement.clientWidth; //获取浏览器窗口的可视区域的宽度

//商家状态
const companyStatus = [
  {
    value: "1",
    label: "正常",
  },
  {
    value: "0",
    label: "禁用",
  },
]

function getMenuUrl() {
  // 接口地址统一从环境变量读取，地址变更只需修改 config/api.config.js
  let propurls;
  if (process.env.NODE_ENV === "development") {
    propurls = (process.env.API_URL || 'http://192.168.0.107:8080') + '/';
  } else {
    propurls = (process.env.BASE_API || 'https://api.yuntiankuajing.com') + '/';
  }
  return propurls;
}


const pageArr = [5, 10, 20, 50, 100];
const pageSize = 10;

// 所属平台
const allPlatform = [
  { value: 10000, label: 'lazada' },
  { value: 10001, label: 'shopee' },
  { value: 10002, label: 'Tiktok' },
  //{ value: 10003, label: 'Wildberries' },
  //{ value: 10004, label: 'Ozon' },
];

// 所属平台状态转文字
function getAllPlatformList(val) {
  const item = this.allPlatform.find(item => Number(item.value) === Number(val));
  return item ? item.label : '';
}

// 商品类型
const goodsType = [
  { id: 1, name: '普货' },
  { id: 2, name: '敏感货' },
  { id: 3, name: '特货' },
];
// 商品类型转文字
function getGoodsTypeList(val) {
  const item = this.goodsType.find(item => Number(item.id) === Number(val));
  return item ? item.name : '';
}

/** 审核状态 */
export const typeList = [
  { value: 0, label: '待审核' },
  { value: 1, label: '已审核' },
];

// 审核状态转文字
function getTypeList(val) {
  const item = this.typeList.find(item => Number(item.value) === Number(val));
  return item ? item.label : '';
}

// 支付类型
export const payTypeList = [
  { id: 1, icon: 'icon-zhifubao', name: '支付宝', url: 'alipay.jpg' },
  
  {
    id: 3,
    icon: 'icon-zhaoshangyinhang1',
    name: '南京银行',
    data: {
      bank: '南京银行',
      subBank: '南京银行和会街支行',
      account: '0166230000000718',
      name: '航向标信息科技（南京）有限公司',
    },
  },
  { id: 2, icon: 'icon-weixinzhifu', name: '微信支付', url: 'wxpay.jpg' },
  {
    id: 4,
    icon: 'icon-zhaoshangyinhang1',
    name: '招商银行',
    data: {
      bank: '招商银行',
      subBank: '招商银行城北支行',
      account: '6226090253143511',
      name: '柯金波',
    },
  },
];

// 支付类型转文字
function getPayTypeListList(val) {
  const item = this.payTypeList.find(item => Number(item.id) === Number(val));
  return item ? item.name : '';
}


/** 任务状态 */
export const taskStatus = [
  { id: 0, name: '待提交', enName: 'pending submission', loading: false },
  { id: 1, name: '待接单', enName: 'pending order', loading: false },
  { id: 2, name: '已接单', enName: 'Order received', loading: false },
  { id: 3, name: '已下单', enName: 'Ordered', loading: false },
  { id: 7, name: '待签收', enName: 'Shipped', loading: false },
  { id: 6, name: '待确认', enName: 'To be confirmed', loading: false },
  { id: -2, name: '下单失败', enName: 'Order failed', loading: false },
  { id: 4, name: '已评论', enName: 'commented', loading: false },
  { id: 5, name: '已完成', enName: 'completed', loading: false },
  { id: -1, name: '已取消', enName: 'canceled', loading: false },
];

// 任务状态转文字
function gettaskStatusList(val, locale) {
  const item = this.taskStatus.find(item => Number(item.id) === Number(val));
  return item ? (locale === 'en' ? item.enName : item.name) : '';
}

// 日期范围快捷键
const pickerOptions = {
  shortcuts: [{
    text: '最近一周',
    onClick(picker) {
      picker.$emit('pick', [dayjs().subtract(7, 'day').toDate(), new Date()]);
    }
  }, {
    text: '最近一个月',
    onClick(picker) {
      picker.$emit('pick', [dayjs().subtract(30, 'day').toDate(), new Date()]);
    }
  }, {
    text: '最近三个月',
    onClick(picker) {
      picker.$emit('pick', [dayjs().subtract(90, 'day').toDate(), new Date()]);
    }
  }]
}
function getScrollTop(that) {
  let overflowY = that.$el.getElementsByClassName("el-table__body-wrapper")[0];
  if (!overflowY) {
    return;
  }
  overflowY.scrollTop = 0;
}
//店铺状态
const storeStatus = [
  {
    value: "1",
    label: "已开启",
  },
  {
    value: "0",
    label: "已关闭",
  },
]


export const accountBillExamineStatus = [
  { id: 0, name: '审核待提交' },
  { id: 1, name: '运营提交审核中' },
  { id: 2, name: '运营提交审核通过' },
  // { id: 3, name: '商户付款审核待提交' },
  { id: 4, name: '商户付款审核已提交' },
  { id: 5, name: '商户付款审核已通过' },
  { id: -1, name: '运营提交审核驳回' },
  { id: -2, name: '商户提交付款审核驳回' },
  { id: -3, name: '商户代付款账单驳回' },
];

function getAccountBillExamineStatusList(val) {
  const item = this.accountBillExamineStatus.find(item => Number(item.id) === Number(val));
  return item ? item.name : '';
}

export const accountBillStatus = [
  { id: 0, name: '已出账' },
  { id: 1, name: '待付款' },
  { id: 2, name: '已付款' },
];

function getAccountBillStatusList(val) {
  const item = this.accountBillStatus.find(item => Number(item.id) === Number(val));
  return item ? item.name : '';
}
/** 云天头程流程 */
export const processList1 = ['创建采购单', '平台审核', '集货仓收货', '发送物流商', '海外仓收货'];

/** 直发流程 */
export const processList2 = ['创建采购单', '平台审核', '补全货运信息推送', '海外仓收货'];

/** 采购单 服务项 */
export const serviceTagList = ['贴标服务', '组合包装/产品组套', '拆分组合包装', '包装'];

/** 采购单类型 */
export const allPurchaseType = [
  { id: 1, name: '云天头程' },
  { id: 2, name: '直发' },
];
function getallPurchaseType(val) {
  const item = this.allPurchaseType.find(item => Number(item.id) === Number(val));
  return item ? item.name : '';
}
/** 采购单状态列表 */
export const purchaseOrderStatusMap = {
  0: { text: '  待审核', status: '_error' },
  1: { text: '  审核通过', status: '_processing' },
  2: { text: '  运输中', status: '_processing' },
  3: { text: '  已入库', status: '_processing' },
  4: { text: '  集货仓待收货', status: '_processing' },
  5: { text: '  集货仓已收货', status: '_processing' },
  [-1]: { text: '  审核驳回', status: '_default' },
  [-2]: { text: '  已作废', status: '_default' },
  [-4]: { text: '  接收失败', status: '_error' },
};
function transformTimestamp(timestamp) {
  return dayjs(timestamp).format('YYYY-MM-DD  HH:mm:ss');
}
/** 运输方式 */
export const collectionTrackingStyleList = [
  {
    label: '海运',
    value: '海运',
  },
  {
    label: '空运',
    value: '空运',
  },
  {
    label: '陆运',
    value: '陆运',
  },
];
// 仓库状态
export const syncWmsStatus = [
  { id: -1, name: '拦截失败' },
  { id: 0, name: '未推送仓库' },
  { id: 1, name: '已推送仓库' },
  { id: 2, name: '仓库已出库' },
  { id: 3, name: '拦截成功' },
];
// 仓库状态 转文字
function getSyncWmsStatusType(val) {
  const item = this.syncWmsStatus.find(item => Number(item.id) === Number(val));
  return item ? item.name : '';
}
export const isEmptyObj = [
  { id: 0, name: '空包' },
  { id: 1, name: '正常' },
]

/** 私发单类型 */
export const privateOrderType = [
  { id: 1, name: '商家私发' },
  { id: 2, name: '平台私发' },
];
// 私发单类型 转文字
function getprivateOrderType(val) {
  const item = this.privateOrderType.find(item => Number(item.id) === Number(val));
  return item ? item.name : '';
}
/** 私发单审核类型 */
export const shStarts = [
  {
    name: '审核通过',
    id: 1,
  },
  {
    name: '审核不通过',
    id: -1,
  },
]
function renderTime(date) {
  return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
}

/** 账单费用类型 */
export const accountBillType = [
  { id: 1, name: '其他费用' },
  { id: 2, name: '补贴费用' },
  { id: 3, name: '发货服务费' },
  { id: 4, name: '仓租费' },
  { id: 5, name: '退单服务费' },
  { id: 6, name: '采购入库费' },
  { id: 7, name: '测品单费' },
  { id: 8, name: '补发单费' },
  { id: 9, name: '退仓费' },
];

/** 账单费用 其他费用子类型 */
export const accountBillOtherType = [
  { id: 9, name: '贴标服务' },
  { id: 10, name: '耗材' },
  { id: 11, name: '装卸费' },
  { id: 12, name: '其他' },
];
// 账单费用子类型 转文字
function getaccountBillOtherType(val) {
  const item = this.accountBillOtherType.find(item => Number(item.id) === Number(val));
  return item ? item.name : '';
}

export const accountBillSubsidyType = [
  { id: 1, name: '发货服务' },
  { id: 2, name: '仓租' },
  { id: 3, name: '其他优惠' },
  { id: 4, name: '赔偿抵扣' },
  { id: 5, name: '其他' },
];

//支付状态
export const payStatus = [
  { value: -1, label: '审核不通过' },
  { value: 0, label: '待审核' },
  { value: 1, label: '审核通过' },
];

// 支付状态转文字
function getPayStatusList(val) {
  const item = this.payStatus.find(item => Number(item.value) === Number(val));
  return item ? item.label : '';
}

//账号状态
const accountStatus = [
  {
    value: "1",
    label: "正常",
    enName: 'normal'
  },
  {
    value: "0",
    label: "禁用",
    enName: 'dissbled'
  },
]
const accountLogTypeList = [
  { value: "1", label: "发货费", type: '1' },
  { value: "2", label: "材料费", type: '1' },
  { value: "3", label: "私发费", type: '1' },
  { value: "4", label: "仓租费", type: '1' },
  { value: "5", label: "上架费", type: '1' },
  { value: "6", label: "下架费", type: '2' },
  { value: "7", label: "退货费", type: '2' },
  { value: "8", label: "贴标费", type: '1' },
  { value: "9", label: "赔偿抵扣", type: '2' },
  { value: "10", label: "充值", type: '10' },
  { value: "11", label: "仓储费", type: '1' },
  { value: "12", label: "仓储费差额", type: '1' },
]
// 账号类型转文字
function getaccountLogTypeList(val) {
  return this.accountLogTypeList.find(item => Number(item.value) === Number(val));
}

// 账号状态转文字
function getaccountStatusList(val, locale) {
  const item = this.accountStatus.find(item => Number(item.value) === Number(val));
  return item ? (locale === 'en' ? item.enName : item.label) : '';
}
export default {
  accountLogTypeList,
  getaccountLogTypeList,
  accountStatus,
  getaccountStatusList,
  payStatus,
  getPayStatusList,
  getaccountBillOtherType,
  transformTimestamp,
  getallPurchaseType,
  allPurchaseType,
  purchaseOrderStatusMap,
  companyStatus,
  clientHeight,
  clientWidth,
  getMenuUrl,
  loginEffectiveTime,
  pageArr,
  pageSize,
  pickerOptions,
  getScrollTop,
  allPlatform,
  getAllPlatformList,
  payTypeList,
  getPayTypeListList,
  gettaskStatusList,
  taskStatus,
  storeStatus,
  typeList,
  getTypeList,
  accountBillStatus,
  getAccountBillStatusList,
  accountBillExamineStatus,
  getAccountBillExamineStatusList,
  getGoodsTypeList,
  goodsType,
  collectionTrackingStyleList,
  syncWmsStatus,
  getSyncWmsStatusType,
  isEmptyObj,
  privateOrderType,
  getprivateOrderType,
  shStarts,
  renderTime,
  processList1,
  processList2,
  serviceTagList,
  accountBillOtherType,
  accountBillSubsidyType,
  accountBillType
};
</script>



// WEBPACK FOOTER //
// src/utils/global.vue